import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_star_sel",
  "use": "icon-icon_star_sel-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"icon-icon_star_sel\"><path d=\"m7 10.65-3.089 1.886a.5.5 0 0 1-.747-.542l.84-3.52-2.748-2.355a.5.5 0 0 1 .285-.878l3.607-.29 1.39-3.341a.5.5 0 0 1 .924 0l1.39 3.342 3.607.289a.5.5 0 0 1 .285.878L9.996 8.473l.84 3.52a.5.5 0 0 1-.747.543L7 10.65Z\" fill=\"#FFB01A\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol